<script setup>
import SalesReviewReturnHeader from './SalesReviewReturnHeader.vue';
import SalesTransactionDetailContent from './SalesTransactionDetailContent.vue';

defineProps({
  initialTab: { type: String, default: 'sale' },
  showNucleoLink: { type: Boolean, default: true },
  tabOrder: { type: Array, default: undefined },
  transaction: { type: Object, required: true },
});

const emit = defineEmits(['back']);
</script>

<template>
  <div data-testid="sales-detail-view">
    <SalesReviewReturnHeader
      read-only
      :transaction="transaction"
      @back="emit('back')"
    />
    <main
      class="mx-auto flex w-full max-w-[1500px] flex-col gap-5 px-4 py-6 sm:px-6 lg:px-10"
    >
      <SalesTransactionDetailContent
        :initial-tab="initialTab"
        :show-nucleo-link="showNucleoLink"
        :show-summary="false"
        :tab-order="tabOrder"
        :transaction="transaction"
      />
    </main>
  </div>
</template>
